import { Sparkles, CheckSquare, Inbox, Database, Settings, ShieldCheck, LifeBuoy,
  BookOpen, ChartNoAxesCombined, Building2, Plug, LayoutGrid, FileText } from 'lucide-react';

export const inicio = [
  { nameKey: 'navigation.home', pageName: 'Home', path: '/home', icon: Sparkles, zone: 'start' },
  { nameKey: 'nav.first_steps', pageName: 'PrimerosPasosPage', path: '/primeros-pasos',
    icon: CheckSquare, zone: 'setup', showIf: ctx => !ctx.onboardingDone },
];
export const dia = [
  { nameKey: 'navigation.documents', pageName: 'BandejaDocumentos', path: '/bandeja-documentos', icon: Inbox,
    zone: 'daily', descriptionKey: 'navigation.descriptions.documents',
    showIf: ctx => ctx.hasPermission('ocr.review') || ctx.hasPermission('documents.view') },
];
export const analitica = [
  { nameKey: 'navigation.analytics', pageName: 'Insights', path: '/insights', icon: ChartNoAxesCombined,
    zone: 'daily', permission: 'analytics.view', descriptionKey: 'navigation.descriptions.analytics' },
];
export const sistema = [
  { nameKey: 'nav.settings', icon: Settings, zone: 'system', subItems: [
    { nameKey: 'navigation.company', pageName: 'Configuracion', icon: Building2,
      descriptionKey: 'navigation.descriptions.company' },
    { nameKey: 'nav.users_roles', pageName: 'RolesManagement', icon: ShieldCheck, adminOnly: true,
      descriptionKey: 'navigation.descriptions.roles' },
    { nameKey: 'nav.invoicing', pageName: 'Configuracion', id: 'settings-invoicing', icon: FileText,
      path: '/configuracion?section=invoicing', permission: 'invoicing.edit', descriptionKey: 'navigation.descriptions.invoicing_settings' },
    { nameKey: 'nav.fiscal_setup', pageName: 'ConfiguracionFiscal', icon: ShieldCheck, permission: 'fiscal.view', descriptionKey: 'navigation.descriptions.fiscal_setup' },
    { nameKey: 'navigation.imports', pageName: 'DataImport', path: '/datos', icon: Database,
      permission: 'accounting.import', descriptionKey: 'navigation.descriptions.imports' },
    { nameKey: 'navigation.integrations', pageName: 'Configuracion', id: 'settings-integrations',
      path: '/configuracion?section=integraciones', icon: Plug, adminOnly: true, descriptionKey: 'navigation.descriptions.integrations' },
    { nameKey: 'navigation.preferences', pageName: 'Configuracion', id: 'settings-modules',
      path: '/configuracion?section=modules', icon: LayoutGrid, adminOnly: true, descriptionKey: 'navigation.descriptions.preferences' },
  ] },
  { nameKey: 'navigation.help', icon: LifeBuoy, zone: 'system', subItems: [
    { nameKey: 'nav.docs', pageName: 'UserManual', icon: BookOpen, descriptionKey: 'navigation.descriptions.docs' },
    { nameKey: 'nav.support', pageName: 'Soporte', icon: LifeBuoy, descriptionKey: 'navigation.descriptions.support' },
  ] },
];
export const nav = [...inicio, ...dia, ...analitica, ...sistema];
